export default "__VITE_ASSET__CF8bYkUy__"